export default "__VITE_ASSET__BHs6nQw3__"